import React, { useState, useEffect } from "react";
import { scrollToSection } from "../../common/scrollFunctions";

function Navbar() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    // Define as funções globais para abrir e fechar o modal
    window.openModal = () => setIsModalOpen(true);
    window.closeModal = () => setIsModalOpen(false);

    return () => {
      // Remove as funções globais quando o componente for desmontado
      delete window.openModal;
      delete window.closeModal;
    };
  }, []);

  return (
    <>
      <nav className="navbar tc-navbar-style5">
        <div className="container d-flex align-items-center justify-content-between">
          <div className="logo text-center mb-lg-0 d-inline-block">
            <img src="/home_borin/assets/images/logo.svg" alt="logo da Wiser" />
          </div>

          <div className="d-none d-xl-block flex-grow-1 ms-50">
            <div className="nav-links font-neue-regular lh-2 ltspc-2">
              <a className="me-50 text-uppercase cursor-pointer">
                <span className="txt"> início </span>
              </a>
              <a
                onClick={() => scrollToSection("id_about")}
                className="me-50 text-uppercase cursor-pointer"
              >
                <span className="txt"> sobre </span>
              </a>
              <a
                onClick={() => scrollToSection("id_residence")}
                className="me-50 text-uppercase cursor-pointer"
              >
                <span className="txt"> residence </span>
              </a>
              <a
                onClick={() => scrollToSection("id_health")}
                className="me-50 text-uppercase cursor-pointer"
              >
                <span className="txt"> health </span>
              </a>
              <a
                onClick={() => scrollToSection("id_socialClub")}
                className="me-50 text-uppercase cursor-pointer"
              >
                <span className="txt"> social club </span>
              </a>
            </div>
          </div>

          <div className="d-flex align-items-center btns-container">
            <button
              onClick={() => window.openModal()}
              className="d-none d-xl-block butn border rounded-pill border-brown1 hover-bg-brown1 text-uppercase color-brown1 wow zoomIn slow"
            >
              <span className="ltspc-1"> Quero saber mais </span>
            </button>
            <a href="#" className="icon ms-4 side_menu_btn">
              <span>
                {" "}
                <i className="la la-grip-lines"></i>{" "}
              </span>
            </a>
          </div>
        </div>
      </nav>

      {isModalOpen && (
        <>
          <div
            className="custom-modal-overlay"
            onClick={() => window.closeModal()}
          ></div>
          <div
            className="custom-modal-wrapper"
            style={{ top: `${window.scrollY + 15}px` }}
            onClick={(e) => e.stopPropagation()} // IMPEDINDO O FECHAMENTO AO CLICAR DENTRO
          >
            <div className="custom-modal">
              <div className="custom-modal-header">
                <h5></h5>
                <button
                  className="btn-close"
                  onClick={() => window.closeModal()}
                >
                  <i className="la la-times"></i>
                </button>
              </div>
              <div className="custom-modal-body">
                <iframe
                  src="https://docs.google.com/forms/d/e/1FAIpQLSe5EomtNGmrWKUS-bUYrlhD3gzhRu71zMaW-dMf7cyafEJTGg/viewform?embedded=true"
                  width="100%"
                  height="959"
                  frameborder="0"
                  marginheight="0"
                  marginwidth="0"
                >
                  Loading…
                </iframe>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default Navbar;
